import React, { useEffect, useState } from "react";
import Carousel from "react-material-ui-carousel";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getPercentage,
  getToken,
  isProductInWishList,
  percentage,
} from "../../resources/helper/helper";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/features/cartSlice";
import {
  addToWishlist,
  removeFromWishlist,
} from "../../redux/features/wishlistSlice";
import { toast } from "react-toastify";
import ReviewForm from "../../Components/ReviewForm";
import { compareProduct } from "../../redux/features/productSlice";
import { CircularProgress } from "@mui/material";

export default function ProductDetail() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = getToken();
  const { topSellingProducts, topRatedProducts, compareLoading } = useSelector(
    (state) => state.product
  );
  const [product, setProduct] = useState(null);
  const [items, setItems] = useState(1);
  const [isAdded, setIsAdded] = useState(false);

  useEffect(() => {
    if (location.state) {
      setProduct(location.state);
    } else {
      navigate("/");
    }
  }, [location.state]);

  const handleDetails = (product) => {
    if (product) {
      setProduct(product);
    }
  };

  const handleCart = () => {
    dispatch(addToCart({ ...product, quantity: items }));
    toast.success("Added successfully!", {
      position: "top-center",
      theme: "colored",
    });
  };

  const handleWishlist = () => {
    const flag = isProductInWishList(product?._id);
    setIsAdded(flag);
    if (!flag) {
      dispatch(addToWishlist({ ...product }));
      toast.success("Product Added to your wishlist!", {
        position: "top-center",
        theme: "colored",
      });
    } else {
      dispatch(removeFromWishlist(product?._id));
      toast.error("Product Removed from wishlist!", {
        position: "top-center",
        theme: "colored",
      });
    }
  };

  const handleCompare = () => {
    if (token && product) {
      const payload = {
        token,
        productId: product?._id,
      };
      dispatch(compareProduct(payload))
        .unwrap()
        .then((res) => {
          console.log("Handle Compare Response", res?.comparisonAnalysis);
          if (res?.comparisonAnalysis?.length > 1) {
            navigate("/compare", { state: res?.comparisonAnalysis });
          } else {
            toast.error("There isn't any similar product", {
              position: "top-center",
              theme: "colored",
            });
          }
        })
        .catch((err) => {
          toast.error(err, {
            position: "top-center",
            theme: "colored",
          });
        });
    }
  };
  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span />
              <a>{product?.category}</a>
              <span /> {product?.name}
            </div>
          </div>
        </div>
        <div className="container mb-30">
          <div className="row">
            <div className="col-xl-11 col-lg-12 m-auto">
              <div className="row">
                <div className="col-xl-9">
                  <div className="product-detail accordion-detail">
                    <div className="row mb-50 mt-30">
                      <div className="col-md-6 col-sm-12 col-xs-12 mb-md-0 mb-sm-5">
                        <div className="detail-gallery">
                          <span className="zoom-icon">
                            <i className="fi-rs-search" />
                          </span>
                          <div
                            className="product-image-slider"
                            style={{ height: "500px" }}
                          >
                            {product?.media?.length > 0 ? (
                              <Carousel
                                autoPlay
                                indicators
                                navButtonsAlwaysVisible
                                animation="slide"
                              >
                                {product?.media?.map((item, i) => (
                                  <figure
                                    className="border-radius-10"
                                    key={i}
                                    style={{ width: "100%", height: "100%" }}
                                  >
                                    <img
                                      src={item}
                                      alt="product image"
                                      style={{
                                        width: "100%",
                                        height: "100%",
                                        objectFit: "cover",
                                      }}
                                    />
                                  </figure>
                                ))}
                              </Carousel>
                            ) : (
                              <figure
                                className="border-radius-10"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <img
                                  src={product?.featured_media}
                                  alt="product image"
                                />
                              </figure>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-sm-12 col-xs-12">
                        <div className="detail-info pr-30 pl-30">
                          {product?.stock === 0 && (
                            <span className="stock-status out-stock">
                              {" "}
                              Sale Off{" "}
                            </span>
                          )}
                          <h2 className="title-detail">{product?.name}</h2>
                          <div className="product-detail-rating">
                            <div className="product-rate-cover text-end">
                              <div className="product-rate d-inline-block">
                                <div
                                  className="product-rating"
                                  style={{
                                    width: `${getPercentage(
                                      product?.ratings?.averageRating
                                    )}%`,
                                  }}
                                />
                              </div>
                              <span className="font-small ml-5 text-muted">
                                {`( ${product?.reviews?.length} reviews )`}
                              </span>
                            </div>
                          </div>
                          <div className="clearfix product-price-cover">
                            <div className="product-price primary-color float-left">
                              <span className="current-price text-brand">
                                Rs.{product?.discount_price}
                              </span>
                              <span>
                                <span className="save-price font-md color3 ml-15">
                                  {percentage(
                                    product?.discount_price,
                                    product?.price
                                  )}
                                </span>
                                <span className="old-price font-md ml-15">
                                  Rs.{product?.price}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className="short-desc mb-30">
                            <p className="font-lg">{product?.description}</p>
                          </div>

                          <div className="detail-extralink mb-50">
                            <div className="detail-qty border radius">
                              <a
                                className="qty-down"
                                onClick={() => {
                                  if (items > 1) {
                                    setItems((item) => item - 1);
                                  }
                                }}
                              >
                                <i className="fi-rs-angle-small-down" />
                              </a>
                              <input
                                type="text"
                                name="quantity"
                                className="qty-val"
                                value={items}
                                min={1}
                              />
                              <a
                                className="qty-up"
                                onClick={() => {
                                  setItems((item) => item + 1);
                                }}
                              >
                                <i className="fi-rs-angle-small-up" />
                              </a>
                            </div>
                            <div className="product-extra-link2">
                              <button
                                onClick={handleCart}
                                className="button button-add-to-cart"
                              >
                                <i className="fi-rs-shopping-cart" />
                                Add to cart
                              </button>
                              <a
                                aria-label="Add To Wishlist"
                                onClick={handleWishlist}
                              >
                                <i
                                  className="fi-rs-heart"
                                  style={{ color: !isAdded && "red" }}
                                />
                              </a>
                              <a
                                aria-label="Compare"
                                className="action-btn hover-up"
                                onClick={handleCompare}
                              >
                                {compareLoading ? (
                                  <CircularProgress
                                    size={16}
                                    color="secondary"
                                  />
                                ) : (
                                  <i className="fi-rs-shuffle" />
                                )}
                              </a>
                            </div>
                          </div>
                          <div className="font-xs">
                            <ul className="float-start">
                              <li>
                                <strong>Stock:</strong>
                                <span className="in-stock text-brand ml-5">
                                  {product?.stock > 0
                                    ? `${product?.stock} Items In Stock`
                                    : "Out of Stock"}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="product-info">
                      <div className="tab-style3">
                        <ul className="nav nav-tabs text-uppercase">
                          <li className="nav-item">
                            <a
                              className="nav-link active"
                              id="Description-tab"
                              href="#Description"
                              data-bs-toggle="tab"
                            >
                              Description
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="Vendor-info-tab"
                              data-bs-toggle="tab"
                              href="#Vendor-info"
                            >
                              Vendor
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              id="Reviews-tab"
                              data-bs-toggle="tab"
                              href="#Reviews"
                            >
                              Reviews
                            </a>
                          </li>
                        </ul>
                        <div className="tab-content shop_info_tab entry-main-content">
                          <div
                            className="tab-pane fade show active"
                            id="Description"
                          >
                            <div className="">{product?.description}</div>
                          </div>

                          <div className="tab-pane fade" id="Vendor-info">
                            <div className="vendor-logo d-flex mb-30 ">
                              <img
                                src={product?.vendor?.businessImage}
                                style={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: 50,
                                  objectFit: "cover",
                                }}
                                alt=""
                              />
                              <div className="vendor-name ml-15 mt-5">
                                <h6>
                                  <a>{product?.vendor?.businessName}</a>
                                </h6>
                              </div>
                            </div>
                            <ul className="contact-infor mb-50">
                              <li>
                                <img
                                  src="././assets/imgs/theme/icons/icon-location.svg"
                                  alt=""
                                />
                                <strong>Address: </strong>
                                <span>{product?.vendor?.address}</span>
                              </li>
                              <li>
                                <img
                                  src="././assets/imgs/theme/icons/icon-contact.svg"
                                  alt=""
                                />
                                <strong>Contact Seller: </strong>
                                <span>{product?.vendor?.phoneNumber}</span>
                              </li>
                            </ul>

                            <p>{product?.vendor?.description}</p>
                          </div>
                          <div className="tab-pane fade" id="Reviews">
                            {/*Comments*/}
                            <div className="comments-area">
                              <div className="row">
                                <div className="col-lg-8">
                                  <h4 className="mb-30">
                                    Customer questions &amp; answers
                                  </h4>
                                  <div className="comment-list">
                                    {product &&
                                      product?.reviews?.length > 0 &&
                                      product?.reviews?.map((item, index) => (
                                        <div className="single-comment justify-content-between d-flex mb-30">
                                          <div
                                            className="user justify-content-between d-flex"
                                            style={{ width: "100%" }}
                                          >
                                            <div className="thumb text-center">
                                              <img
                                                src={
                                                  "././assets/imgs/blog/author-2.png"
                                                }
                                                alt=""
                                              />
                                              <a className="font-heading text-brand">
                                                {item?.customer?.details?.name}
                                              </a>
                                            </div>
                                            <div
                                              className="desc"
                                              style={{ width: "100%" }}
                                            >
                                              <div
                                                className="d-flex justify-content-between mb-10"
                                                style={{
                                                  width: "100%",
                                                  alignItems: "center",
                                                }}
                                              >
                                                <div className="d-flex align-items-center">
                                                  <span className="font-xs text-muted">
                                                    {item?.date?.slice(0, 10)}
                                                  </span>
                                                </div>
                                                <div className="product-rate d-inline-block">
                                                  <div
                                                    className="product-rating"
                                                    style={{
                                                      width: `${getPercentage(
                                                        item?.stars
                                                      )}%`,
                                                    }}
                                                  />
                                                </div>
                                              </div>
                                              <p className="mb-10">
                                                {item?.comment}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <h4 className="mb-30">Customer reviews</h4>
                                  <div className="d-flex mb-30">
                                    <div className="product-rate d-inline-block mr-15">
                                      <div
                                        className="product-rating"
                                        style={{
                                          width: `${getPercentage(
                                            product?.ratings?.averageRating
                                          )}%`,
                                        }}
                                      />
                                    </div>
                                    <h6>
                                      {product?.ratings?.averageRating} out of 5
                                    </h6>
                                  </div>
                                  <div className="progress">
                                    <span>5 star</span>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${getPercentage(
                                          product?.ratings?.five_star
                                        )}%`,
                                      }}
                                      aria-valuenow={50}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      {`${getPercentage(
                                        product?.ratings?.five_star
                                      )}%`}
                                    </div>
                                  </div>
                                  <div className="progress">
                                    <span>4 star</span>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${getPercentage(
                                          product?.ratings?.four_star
                                        )}%`,
                                      }}
                                      aria-valuenow={25}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      {`${getPercentage(
                                        product?.ratings?.four_star
                                      )}%`}
                                    </div>
                                  </div>
                                  <div className="progress">
                                    <span>3 star</span>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${getPercentage(
                                          product?.ratings?.three_star
                                        )}%`,
                                      }}
                                      aria-valuenow={45}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      {`${getPercentage(
                                        product?.ratings?.three_star
                                      )}%`}
                                    </div>
                                  </div>
                                  <div className="progress">
                                    <span>2 star</span>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${getPercentage(
                                          product?.ratings?.two_star
                                        )}%`,
                                      }}
                                      aria-valuenow={65}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      {`${getPercentage(
                                        product?.ratings?.two_star
                                      )}%`}
                                    </div>
                                  </div>
                                  <div className="progress mb-30">
                                    <span>1 star</span>
                                    <div
                                      className="progress-bar"
                                      role="progressbar"
                                      style={{
                                        width: `${getPercentage(
                                          product?.ratings?.one_star
                                        )}%`,
                                      }}
                                      aria-valuenow={85}
                                      aria-valuemin={0}
                                      aria-valuemax={100}
                                    >
                                      {`${getPercentage(
                                        product?.ratings?.one_star
                                      )}%`}
                                    </div>
                                  </div>
                                  <a className="font-xs text-muted">
                                    How are ratings calculated?
                                  </a>
                                </div>
                              </div>
                            </div>
                            {/*comment form*/}
                            <ReviewForm productId={product?._id} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-3 primary-sidebar sticky-sidebar mt-30">
                  {/* categories */}
                  {topRatedProducts && topRatedProducts?.length > 0 && (
                    <div className="sidebar-widget product-sidebar mb-30 p-30 bg-grey border-radius-10">
                      <h5 className="section-title style-1 mb-30">Top Rated</h5>
                      {topRatedProducts?.map((item, index) => (
                        <div
                          className="single-post clearfix"
                          key={index}
                          onClick={() => {
                            handleDetails(item);
                          }}
                        >
                          <div className="image">
                            <img src={item?.featured_media} alt="#" />
                          </div>
                          <div className="content pt-10">
                            <h5>
                              <a>{item?.name}</a>
                            </h5>
                            <p className="price mb-0 mt-5">
                              Rs.{item?.discount_price}
                            </p>
                            <div className="product-rate">
                              <div
                                className="product-rating"
                                style={{
                                  width: `${getPercentage(
                                    item?.ratings?.averageRating
                                  )}%`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {topSellingProducts && topSellingProducts?.length > 0 && (
                    <div className="sidebar-widget product-sidebar mb-30 p-30 bg-grey border-radius-10">
                      <h5 className="section-title style-1 mb-30">
                        Top Selling
                      </h5>
                      {topSellingProducts?.map((item, index) => (
                        <div
                          className="single-post clearfix"
                          key={index}
                          onClick={() => {
                            handleDetails(item);
                          }}
                        >
                          <div className="image">
                            <img src={item?.featured_media} alt="#" />
                          </div>
                          <div className="content pt-10">
                            <h5>
                              <a>{item?.name}</a>
                            </h5>
                            <p className="price mb-0 mt-5">
                              Rs.{item?.discount_price}
                            </p>
                            <div className="product-rate">
                              <div
                                className="product-rating"
                                style={{
                                  width: `${getPercentage(
                                    item?.ratings?.averageRating
                                  )}%`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  <div className="banner-img wow fadeIn mb-lg-0 animated d-lg-block d-none">
                    <img src="././assets/imgs/banner/banner-11.png" alt="" />
                    <div className="banner-text">
                      <span>Oganic</span>
                      <h4>
                        Save 17% <br />
                        on <span className="text-brand">Oganic</span>
                        <br />
                        Juice
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
